module.exports = __webpack_public_path__ + "static/media/seguros-mundial-vial.2a474586.svg";